import Icon from '../../components/Icon.vue'

Icon.register({"brands/mizuni":{"width":496,"height":512,"paths":[{"d":"M248 8C111 8 0 119.1 0 256 0 393 111 504 248 504S496 393 496 256C496 119.1 385 8 248 8zM168 359.9C136.6 370.5 109.2 387.2 88 408.1V136C88 113.9 105.9 96 128 96S168 113.9 168 136V359.9zM288 350C275.1 348 261.8 346.9 248.2 346.9 234.4 346.9 221 348 208 350V136C208 113.9 225.9 96 248 96S288 113.9 288 136V350zM408 407.7C386.8 386.9 359.4 370.3 328 359.7V136C328 113.9 345.9 96 368 96S408 113.9 408 136V407.7z"}]}})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/mizuni.js
// module id = ek3K
// module chunks = 0